import { stringifySafe } from '../json/stringify-safe.util';

/**
 * Formats unvalidated values without losing structured content to object coercion.
 * @param value - Scalar or structured value from a workflow or API response.
 * @returns Scalar text, JSON for objects, or an empty string for missing values.
 */
export const formatUnknownValue = (value: unknown): string => {
  switch (typeof value) {
    case 'undefined':
      return '';
    case 'string':
      return value;
    case 'number':
    case 'boolean':
    case 'bigint':
    case 'symbol':
      return String(value);
    case 'function':
      return value.toString();
    case 'object':
      return value === null ? '' : stringifySafe(value);
  }
};
